import * as React from "react";
import { SpecificationSelectModal } from "src/business/specification/SpecificationSelect/SpecificationSelectModal";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { SelectFromModalButton } from "src/components/SelectFromModalButton";
import { ZSidLabel } from "src/types";

import { specLoader } from "../apiSpecifications";
import {
  SpecificationsFilter,
  SpecificationType,
  ZSpecification,
} from "../ZSpecification";

type PropsSpecificationSelect = {
  specType: SpecificationType;
  multi?: boolean;
  value?: ZSidLabel | ZSidLabel[];
  onChange?(newValue?: ZSidLabel | ZSidLabel[]): void;
  disabled?: boolean;
};

export const SpecificationSelect: React.FC<PropsSpecificationSelect> = (
  props,
) => {
  const { specType, multi, value, onChange, disabled } = props;

  const options = React.useMemo<ZSidLabel[]>(() => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  }, [value]);

  const [tableStore, setTableStore] = React.useState<
    RtStore<ZSpecification, SpecificationsFilter> | undefined
  >();

  const onChangeLocal = (newValue: ZSidLabel[] | null) => {
    if (multi) {
      onChange?.(newValue ?? []);
    } else {
      onChange?.(newValue?.[0]);
    }
  };

  const createStore = () => {
    const store = new RtStore<ZSpecification, SpecificationsFilter>({
      rowKey: "id",
      loader: specLoader(specType),
      selectionType: multi ? "checkbox" : "radio",
      keepSelected: true,
      defaultRequest: {
        pageSize: 20,
      },
    });

    store.setSelectedKeys(options.map(({ id }) => id));
    setTableStore(store);
  };

  return (
    <SelectFromModalButton
      disabled={disabled}
      options={options}
      multi={multi}
      onChange={onChangeLocal}
      onOpen={createStore}
    >
      <SpecificationSelectModal
        specType={specType}
        tableStore={tableStore}
        srcSelected={options}
        close={() => setTableStore(undefined)}
        onApply={onChangeLocal}
      />
    </SelectFromModalButton>
  );
};
